export default function validate(value, props) {
    const { messages, locale, noUppercaseLangs } = props;
    const { language } = locale;

    const passwordMinLength = 8;
    const passwordMaxLength = 64;

    const noUppercaseLang = noUppercaseLangs?.includes(language.toUpperCase());
    const charError = !noUppercaseLang && !value?.match(/[A-Z]/);

    if (!value || !value.trim()) {
        return messages.errors.required({ field: messages.loginForm.logonPassword() });
    } else if (value.length < passwordMinLength) {
        return messages.errors.minLength({ characters: passwordMinLength });
    } else if (value.length > passwordMaxLength) {
        return messages.errors.maxLength({ characters: passwordMaxLength });
    } else if (value.match(/\s/)) {
        return messages.errors.containsWhitespace();
    } else if (value.toLowerCase().match(/(.)(.*\1){4}/)) {
        return messages.errors.characterOccurrence({ occurrence: 4 });
    } else if (value.toLowerCase().includes('password')) {
        return messages.errors.containsPassword();
    } else if (!value.toLowerCase().match(/\d/)) {
        return messages.errors.mustContainNumber({ occurrence: 1 });
    } else if (charError) {
        return messages.errors.mustContainUppercase();
    } else if (value?.toLowerCase().match(/(.)\1{3,}/)) {
        return messages.errors.characterRepeats({ repeats: 3 });
    }
}
